<template>
  <div class="table-default-cell" :style='cssValues'>
    {{ item[category.field] }}
  </div>
</template>

<script>
export default {
  name: 'TableDefaultCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cssValues() {
      return {
        '--width': this.width,
      };
    },
    width() {
      if (this.item.width) {
        return `${this.item.width}px`;
      }
      return 'initial';
    },
  },
};
</script>

<style lang='scss' scoped>
.table-default-cell {
  width: var(--width);
}
</style>
